// extracted by mini-css-extract-plugin
module.exports = {"sectionContainer":"Video_sectionContainer__pd45P","videoContainer":"Video_videoContainer__NAKaZ","fade-in-video":"Video_fade-in-video__vlY34"};